export enum CargoType {
    NORMATIVE_TRAILER = "NORMATIVE_TRAILER",
    NORMATIVE_CONTAINER = "NORMATIVE_CONTAINER",
    NORMATIVE_GENERAL_CARGO = "NORMATIVE_GENERAL_CARGO",
    DANGEROUS_TRAILER = "DANGEROUS_TRAILER",
    DANGEROUS_CONTAINER = "DANGEROUS_CONTAINER",
    DANGEROUS_GENERAL_CARGO = "DANGEROUS_GENERAL_CARGO",
    OVERSIZE = "OVERSIZE",
    LORRY = "LORRY",
    OVERSIZE_LORRY = "OVERSIZE_LORRY",
    DANGEROUS_LORRY = "DANGEROUS_LORRY",
    OVERSIZE_TRAILER = "OVERSIZE_TRAILER"
}